module.exports = new __parcel__URL__("activity.tpl.a0cf9ae0.svg").toString();